import styled from 'styled-components';

export const UsersActionsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 1rem;
`;

export const NewUserModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
`;

export const NewUserModalInputsContainer = styled.div`
  display: flex;
  gap: 1rem;
`;

export const NewUserModalFeaturesContainer = styled.div``;

export const NewUserModalActionsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
`;
